class BaseFacetFilters extends HTMLElement {
  constructor() {
    super();
    this.currentForm = this.querySelector("form.facets");
    this.facetFilters = [];
    this.isMobile = window.matchMedia("(max-width: 989px)").matches;

    this.isMobile ? this.initMobileFilters() : this.initDesktopFilters();

    this.elementSelectors = {
      productGrid: "main #product-grid",
      searchHeaderProductGrid: "search-results #product-grid",
      facetDrawerGroups: [],
      activeFacets: "[data-active-facets]",
      activeFacetsCount: "[data-active-facets-count]",
      activeFacetsGroupCount: [],
      productsCount: "[data-products-count]",
      selectSortBy: "#DetailsSortBy",
      paginationSelector: ".pagination-wrapper",
      clearAllSelector: "facets-clear-all",
      collapsibleFacetContent: "accordion-custom.facet-group",
    };

    this.classes = {
      loading: "loading",
    };

    document.querySelectorAll(this.elementSelectors.collapsibleFacetContent).forEach((facetGroup) => {
      this.elementSelectors.activeFacetsGroupCount.push(`#${facetGroup.id} [data-active-facets-group-count]`);
    });

    document.querySelectorAll(this.elementSelectors.collapsibleFacetContent).forEach((facetGroup) => {
      this.elementSelectors.facetDrawerGroups.push(`#${facetGroup.id} .details-content`);
    });

    if (this.elementSelectors.facetDrawerGroups.length === 0) {
      return;
    }

    this.setElements();

    window.addEventListener("resize", () => {
      const mobile = window.matchMedia("(max-width: 989px)").matches;

      const desktopFilter = this.querySelector(".js-filters-desktop");
      const mobileDrawer = this.querySelector(".js-filters-drawer");

      if (mobile) {
        if (desktopFilter) desktopFilter.style.display = "none";
        if (mobileDrawer) mobileDrawer.style.display = "block";
      } else {
        if (desktopFilter) desktopFilter.style.display = "block";
        if (mobileDrawer) mobileDrawer.style.display = "none";
      }
    });
  }

  initMobileFilters() {
    const desktop = this.querySelector(".js-filters-desktop");

    if (desktop) desktop.style.display = 'none';
  }

  initDesktopFilters() {
    const drawer = this.querySelector(".js-filters-drawer");

    if (drawer) drawer.style.display = 'none';
  }

  setElements() {
    if (!this.isHeaderSearchOpen()) {
      this.productGridEl = document.querySelectorAll(this.elementSelectors.productGrid);
    } else {
      this.productGridEl = document.querySelectorAll(this.elementSelectors.searchHeaderProductGrid);
    }

    this.facetDrawerGroupsEl = document.querySelectorAll(this.elementSelectors.facetDrawerGroups);
    this.activeFacets = document.querySelectorAll(this.elementSelectors.activeFacets);
    this.activeFacetsCountEl = document.querySelectorAll(this.elementSelectors.activeFacetsCount);
    this.activeFacetsGroupCountEl = document.querySelectorAll(this.elementSelectors.activeFacetsGroupCount);
    this.productsCountEl = document.querySelectorAll(this.elementSelectors.productsCount);
    this.selectSortByEl = document.querySelectorAll(this.elementSelectors.selectSortBy);
    this.paginationSelectorEl = document.querySelectorAll(this.elementSelectors.paginationSelector);
    this.clearAllSelectorEl = document.querySelectorAll(this.elementSelectors.clearAllSelector);
  }

  getSearchResultsUrl() {
    this.facetFilters = this.getFacetsData();

    let queryString = "";
    for (const key in this.facetFilters) {
      if (this.facetFilters.hasOwnProperty(key)) {
        const values = this.facetFilters[key];
        if (Array.isArray(values)) {
          values.forEach((value) => {
            queryString += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`;
          });
        } else {
          queryString += `${encodeURIComponent(key)}=${encodeURIComponent(values)}&`;
        }
      }
    }
    // Remove the trailing '&'
    queryString = queryString.slice(0, -1);

    return `${window.Shopify.routes.root}search?${queryString}`;
  }

  getFacetsData() {
    this.currentForm = this.querySelector("form.facets");

    let formData = new FormData(this.currentForm);

    const data = {};
    formData.forEach((value, key) => {
      if (data[key]) {
        if (!Array.isArray(data[key])) {
          data[key] = [data[key]];
        }
        data[key].push(value);
      } else {
        data[key] = value;
      }
    });

    this.formDataAssignCheckboxes(data);
    this.formDataRemoveDuplicates(data);

    return data;
  }

  formDataAssignCheckboxes(data) {
    const checkboxes = this.currentForm.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      if (!data[checkbox.name]) {
        data[checkbox.name] = [];
      }
      if (checkbox.checked) {
        if (Array.isArray(data[checkbox.name])) {
          data[checkbox.name].push(checkbox.value);
        } else {
          data[checkbox.name] = [checkbox.value];
        }
      }
    });
  }

  formDataRemoveDuplicates(data) {
    Object.keys(data).forEach((key) => {
      const value = data[key];
      if (Array.isArray(value)) {
        data[key] = [...new Set(value)];
      }
    });
  }

  updateBrowserURL() {
    this.facetFilters = this.getFacetsData();

    let url = window.location.pathname;

    let params = new URLSearchParams();
    params.delete("page");

    const loadPreviousProductsButton = document.querySelector("load-previous-products");
    loadPreviousProductsButton?.classList.add("hidden");

    Object.keys(this.facetFilters).forEach((key) => {
      const value = this.facetFilters[key];
      if (Array.isArray(value)) {
        value.forEach((v) => params.append(key, v));
      } else {
        params.set(key, value);
      }
    });

    window.history.pushState({}, "", `${url}?${params.toString()}`);
  }

  getParsedData(data) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(data, "text/html");

    return doc;
  }

  scrollPageToTop() {
    if (window.innerWidth <= 749) {
      window.scrollTo(0, 0);
    }
  }

  isHeaderSearchOpen() {
    return document.documentElement.classList.contains("header-search--open");
  }

  updateElements(data, previousData) {
    this.parsedDoc = this.getParsedData(data);
    this.previousData = previousData;

    this.updateProductGrid();

    this.updateFacetDrawer();
    this.updateActiveFacets();
    this.updateActiveFacetsCount();
    this.updateClearAllVisibility();
    this.updateActiveFacetsGroupCount();
    this.updateProductsCount();
    this.updateSortBy();
    this.scrollPageToTop();

    if (!this.previousData) {
      this.updatePagination();
    } else {
      this.updatePreviousButton();
      document.dispatchEvent(new CustomEvent("previous-items-loaded"));
    }
  }

  getPreviousData() {
    return fetch(window.location.href)
      .then((response) => response.text())
      .then((data) => {
        this.updateElements(data, true);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  setGroupLoadingState(collapsibleContent, state) {
    if (!collapsibleContent) {
      return;
    }

    if (state == "loading") {
      collapsibleContent.classList.add(this.classes.loading);
    } else if (state == "loaded") {
      collapsibleContent.classList.remove(this.classes.loading);
    }
  }

  fetchData(collapsibleContent) {
    this.setGroupLoadingState(collapsibleContent, "loading");


    let url = window.location.href;
    if (document.documentElement.classList.contains("header-search--open")) {
      url = this.getSearchResultsUrl();
    }

    return fetch(url)
      .then((response) => response.text())
      .then((data) => {
        this.updateElements(data);
        this.setGroupLoadingState(collapsibleContent, "loaded");
      })
      .catch((error) => {
        this.setGroupLoadingState(collapsibleContent, "loaded");
        console.error("Error fetching data:", error);
      });
  }

  updatePreviousButton() {
    const loadPreviousProductsButton = document.querySelector("load-previous-products");
    loadPreviousProductsButton.classList.remove("loading");

    if (loadPreviousProductsButton.dataset.pageIndex == "1") {
      loadPreviousProductsButton.classList.add("hidden");
    }
  }

  updateProductGrid() {
    this.productGridEl.forEach((element) => {
      const newProductGrid = this.parsedDoc.querySelector(this.elementSelectors.productGrid);

      if (this.previousData) {
        let currentScroll = window.scrollY;
        let oldContentHeight = document.body.scrollHeight;

        const fragment = document.createDocumentFragment();
        Array.from(newProductGrid.children).forEach((child) => fragment.appendChild(child));

        element.prepend(fragment);
        let newContentHeight = document.body.scrollHeight;
        let newScrollPosition = currentScroll + (newContentHeight - oldContentHeight);
        window.scrollTo(0, newScrollPosition);
      } else {
        const fragment = document.createDocumentFragment();
        Array.from(newProductGrid.children).forEach((child) => fragment.appendChild(child));

        element.innerHTML = "";
        element.appendChild(fragment);
      }

      this.renderWishlistButtons();
    });
  }

  renderWishlistButtons() {
    let productGridSelector = "main #product-grid";

    document.dispatchEvent(
      new CustomEvent("swym:refresh-products", {
        detail: {
          selector: productGridSelector,
        },
      })
    );
  }

  updateFacetDrawer() {
    this.facetDrawerGroupsEl.forEach((element) => {
      let facetGroupId = element.closest("accordion-custom.facet-group").id;
      let parsedElement = this.parsedDoc.querySelector(`#${facetGroupId} .details-content`);
      if (parsedElement) {
        element.innerHTML = parsedElement.innerHTML;
      }
    });
  }

  updateActiveFacetsGroupCount() {
    this.activeFacetsGroupCountEl.forEach((element) => {
      let facetGroupId = element.closest("accordion-custom.facet-group").id;
      let parsedElement = this.parsedDoc.querySelector(`#${facetGroupId} [data-active-facets-group-count]`);
      if (parsedElement) {
        element.dataset.activeFacetsGroupCount = parsedElement.dataset.activeFacetsGroupCount;
      }
    });
  }

  updateActiveFacetsCount() {
    this.activeFacetsCountEl.forEach((element) => {
      element.dataset.activeFacetsCount = this.parsedDoc.querySelector(this.elementSelectors.activeFacetsCount).dataset.activeFacetsCount;
    });
  }

  updateActiveFacets() {
    this.activeFacets.forEach((element) => {
      let parsedElement = this.parsedDoc.querySelector("[data-active-facets]");
      if (parsedElement) {
        element.innerHTML = parsedElement.innerHTML;
      }
    });
  }

  updateClearAllVisibility() {
    this.clearAllSelectorEl.forEach((element) => {
      let filters = Object.keys(this.facetFilters).filter((key) => this.facetFilters[key].length > 0);
      filters = filters.filter((key) => key !== "sort_by" && key !== "page");

      if (filters.length > 0) {
        element.classList.remove("hidden");
      } else {
        element.classList.add("hidden");
      }
    });
  }

  updateProductsCount() {
    this.productsCountEl.forEach((element) => {
      const selector = `.${[...element.classList].join('.')}`;
      const parsedEl = this.parsedDoc.querySelector(selector);

      if (!parsedEl) return;

      element.innerHTML = parsedEl.innerHTML;
    });
  }

  updateSortBy() {
    this.selectSortByEl.forEach((element) => {
      const selectSortBy = this.parsedDoc.querySelector(this.elementSelectors.selectSortBy);
      if (!selectSortBy) {
        return;
      }

      element.querySelector('.facet-group--sort-by__value').innerHTML = selectSortBy.querySelector('.facet-group--sort-by__value').innerHTML
    });
  }

  updatePagination() {
    this.paginationSelectorEl.forEach((element) => {
      const paginationSelector = this.parsedDoc.querySelector(this.elementSelectors.paginationSelector);
      if (paginationSelector) {
        element.innerHTML = paginationSelector.innerHTML;
        element.classList.remove("hidden");
      } else {
        element.innerHTML = "";
      }
    });
  }
}

class FacetsFiltersForm extends BaseFacetFilters {
  constructor() {
    super();
  }

  connectedCallback() {
    this.currentForm.addEventListener("change", (evt) => {
      const collapsibleContent = evt.target.closest("accordion-custom");

      if (this.isHeaderSearchOpen()) {
        this.getFacetsData();
        this.fetchData(collapsibleContent);
      } else {
        this.updateBrowserURL();
        this.fetchData(collapsibleContent);
      }
    });
  }
}

class FacetsSortBy extends BaseFacetFilters {
  connectedCallback() {
    this.selectEl = this.querySelector("select");
    this.trigger = this.querySelector(".custom-select__trigger");
    this.valueEl = this.querySelector(".custom-select__value");
    this.options = this.querySelectorAll(".custom-select__option");

    const params = new URLSearchParams(window.location.search);
    const sortBy = params.get("sort_by") || this.selectEl.value;

    this.syncFromValue(sortBy);

    this.selectEl.addEventListener("change", this.onSelectChange);
    this.trigger.addEventListener("click", this.toggle.bind(this));

    this.options.forEach(option => {
      option.addEventListener("click", (evt) => {
        evt.stopPropagation();
        this.onOptionClick(option);
      });
    });

    document.addEventListener("click", this.handleClickOutside);
  }

  disconnectedCallback() {
    this.selectEl.removeEventListener("change", this.onSelectChange);
    document.removeEventListener("click", this.handleClickOutside);
  }


  handleClickOutside = (evt) => {
    if (!this.contains(evt.target)) {
      this.close();
    }
  };

  disconnectedCallback() {
    this.selectEl.removeEventListener("change", this.onSelectChange);
  }

  toggle(evt) {
    evt?.stopPropagation();

    const isOpen = this.classList.contains("is-open");
    isOpen ? this.close() : this.open();
  }

  open() {
    this.trigger.setAttribute("aria-expanded", "true");
    this.classList.add("is-open");
  }

  close() {
    this.trigger.setAttribute("aria-expanded", "false");
    this.classList.remove("is-open");
  }


  onOptionClick(option) {
    const value = option.dataset.value;

    this.selectEl.value = value;
    this.selectEl.dispatchEvent(new Event("change", { bubbles: true }));

    this.valueEl.textContent = option.textContent;

    this.options.forEach(opt => opt.removeAttribute("aria-selected"));
    option.setAttribute("aria-selected", "true");

    this.toggle();
  }

  onSelectChange = () => {
    const selectedValue = this.selectEl.value;
    this.updateBrowserURL(selectedValue);
  };

  updateBrowserURL(selectedValue) {
    const params = new URLSearchParams(window.location.search);
    params.set("sort_by", selectedValue);
    params.delete("page");

    document
      .querySelector("load-previous-products")
      ?.classList.add("hidden");

    window.history.pushState({}, "", `${window.location.pathname}?${params}`);
    this.fetchData();
  }

  syncFromValue(value) {
    this.selectEl.value = value;

    const activeOption = [...this.options].find(opt => opt.dataset.value === value);
    if (!activeOption) return;

    this.valueEl.textContent = activeOption.textContent;
    this.options.forEach(opt => opt.removeAttribute("aria-selected"));
    activeOption.setAttribute("aria-selected", "true");
  }
}

class FacetsClearAllButton extends BaseFacetFilters {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", (evt) => {
      evt.preventDefault();

      const clearAll = this.querySelector(".facets__clear");
      if (!clearAll) return;

      const resultsUrl = clearAll.getAttribute("href");

      window.history.pushState({}, "", resultsUrl);

      const loadPreviousProductsButton = document.querySelector("load-previous-products");
      loadPreviousProductsButton?.classList.add("hidden");

      this.fetchData();
    });
  }
}

customElements.define("facets-filters-form", FacetsFiltersForm);
customElements.define("facets-sort-by", FacetsSortBy);
customElements.define("facets-clear-all", FacetsClearAllButton);
